import { useEffect, useState } from "react"
import consumer from "../channels/consumer"

// Subscribes to GTM::PipelineChannel for a pipeline and tracks a map of
// edge_id → counts. Input steps don't have step_executions in the engine,
// so there are no input-keyed broadcasts — their size shows as a snapshot
// (inputSummary on the node payload).
//
// Full snapshots, not deltas — dropped frames don't desynchronize.
//
// `window.__gtmReceiveCounts(payload)` is exposed for headless-browser tests
// to drive the React state → DOM path without a real WebSocket transport.
// Production code never reaches into window. Cable transport is covered by
// pipeline_channel_spec + counts_broadcaster_spec server-side.
export default function usePipelineCounters(pipelineId, initialEdgeCounts = {}) {
  const [edgeCounts, setEdgeCounts] = useState(initialEdgeCounts)

  useEffect(() => {
    if (!pipelineId) return undefined

    const receive = data => {
      if (!data?.edge_id) return
      setEdgeCounts(prev => ({ ...prev, [data.edge_id]: data.counts }))
    }

    const subscription = consumer.subscriptions.create(
      { channel: "GTM::PipelineChannel", pipeline_id: pipelineId },
      { received: receive }
    )

    if (typeof window !== "undefined") {
      window.__gtmReceiveCounts = receive
    }

    return () => {
      subscription.unsubscribe()
      if (typeof window !== "undefined") delete window.__gtmReceiveCounts
    }
  }, [pipelineId])

  return edgeCounts
}
